import axios from 'axios'

export default {

    /**
     * Get banners
     * @returns {AxiosPromise<any>}
     */
    get(params = {}) {
        return axios.get('/api/articles', { params })
    },

    /**
     * Get single page by slug.
     *
     * @param slug
     * @returns {AxiosPromise<any>}
     */
    find(slug) {
        return axios.get('/api/articles/' + slug)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/api/posts.js